import EntityAutocomplete from '@/@core/components/entity-autocomplete/EntityAutocomplete.vue';
import EntitySelect from '@/@core/components/entity-select/EntitySelect.vue';
import ListSelect from '@/@core/components/list-select/ListSelect.vue';
import Vue from 'vue';

Vue.component('entity-autocomplete', EntityAutocomplete);
Vue.component('entity-select', EntitySelect);
Vue.component('list-select', ListSelect);